import * as React from "react"
import {Box} from "@mui/material";
import {CardSeeker} from "@ui-seeker/core";
import {formatDate} from "@ui-seeker/utils";

import {PercentageChartNew} from "@components";
import {BANNERS_ROUTES, DATE_METRICS} from "@constants";
import {useBannerPercentageReach, useBannersPercentageLink} from "../@hooks";
import BannersPercentageReachSkeleton from "./Skeleton";
import BannerPercentageToolbar from "../Toolbar";


export default function BannersPercentageReach() {
    const {
        isLoading, data, totalKey, shareKey, handleChangeTotalKey, handleChangeShareKey, totalTitle, shareTitle, isClickedRemaining, handleDownload
    } = useBannerPercentageReach()
    const { buildLink } = useBannersPercentageLink(BANNERS_ROUTES.TOP_BANNERS_PATH)

    if (isLoading) return <BannersPercentageReachSkeleton isLoading={isLoading} />
    if (!data.length) return <></>

    return <CardSeeker
        title={`Reach by ${totalTitle} & ${shareTitle}`}
        actions={<BannerPercentageToolbar
            metricSelected={totalKey}
            groupedBySelected={shareKey}
            onChangeMetric={handleChangeTotalKey}
            onChangeGroupedBy={handleChangeShareKey}
            onDownload={handleDownload}
        />}
    >
        <Box display="flex" justifyContent="space-around" width={1} gap={1} sx={{ overflowX: "auto" }}>
            { data.map(({ label, country, rows, ...rowData }, idx) => {
                //Logic: Este catch evita los tiempos de renderizado en los que cambiamos la metrica pero aún no está en loading el dashboard
                let labelFormatted = label
                try {
                    labelFormatted = totalKey === DATE_METRICS.DAILY ? formatDate(label, {isString: true}) : label
                } catch { labelFormatted = label }

                return <Box key={idx}>
                    <PercentageChartNew
                        column
                        label={labelFormatted}
                        data={rows.map(d => ({
                            ...d,
                            width: d.share,
                            link: d.remainingData
                                ? d.remainingData.length && isClickedRemaining ? buildLink({...rowData, ...d}) : null
                                : buildLink({...rowData, ...d})
                        }))}
                    />
                </Box>
            }) }
        </Box>
    </CardSeeker>
}